<template>
  <b-container fluid>
    <h2 class="mt-5">Officials</h2>
    <b-tabs>
      <b-tab title="All">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
      <b-tab title="Referees">
        <b-list-group>
          <b-list-group-item class="d-flex align-items-center">
            <b-avatar class="mr-3"></b-avatar>
            <span class="mr-auto">Franz Schwerdtmann</span>
          </b-list-group-item>
          <b-list-group-item class="d-flex align-items-center">
            <b-avatar class="mr-3"></b-avatar>
            <span class="mr-auto">Franz Schwerdtmann</span>
          </b-list-group-item>
        </b-list-group>
      </b-tab>
      <b-tab title="Judges">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
      <b-tab title="Inspectors">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
      <b-tab title="Cutmen">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
      <b-tab title="Doctors">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
      <b-tab title="Others">
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center">
          <b-avatar class="mr-3"></b-avatar>
          <span class="mr-auto">Franz Schwerdtmann</span>
        </b-list-group-item>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
export default {
  name: 'Officials',
};
</script>

<style scoped>

</style>
